import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { showTemporaryMessage } from "../components/Message";
import { AuthContext } from '../components/AuthProvider';

import PickUser from '../components/PickUser';
import PickBearer from '../components/PickBearer';
import ListOfBearers from '../components/ListOfBearers';
import ScanTokens from '../components/ScanTokens';

const Scans = () => {
	const { t } = useTranslation();
	const { userType, loginToken, userId } = React.useContext(AuthContext);

	const [selectedUserId, setSelectedUserId] = useState(0);
	// TODO: Remove?
	// Dummy value that just triggers a refresh of PickUser
	const [refreshTrigger, setRefreshTrigger] = useState(0);
	const [selectedBearerId, setSelectedBearerId]	= useState(0);

	/**
	 * REGULAR users can only administer bearers relating to
	 * their own User ID, so we choose this ID for them.
	 */
	useEffect(() => {
		if(userType === 'REGULAR') {
			setSelectedUserId(userId);
		}
	}, []);

	const updateUsersState = () => {
		setRefreshTrigger(prev => prev + 1);
	};
	const updateListOfScanTokens = () => {
		console.log("Scans: updateListOfScanTokens");
	};

	const [refreshBearerListTrigger, setRefreshBearerListTrigger] = useState(0);

	return (
		<div className="flex-grow h-full w-full">
			{/* Heading */}
			<div className="super-admin w-full bg-light-blue shadow mb-10">
				<div className="max-w-screen-xl mx-auto py-4 px-4 text-center sm:text-start">
					<h1 className="text-4xl font-extrabold text-black">{t("page_scans")}</h1>
				</div>
			</div>
			<div className="max-w-screen-xl mx-auto px-4">
				<div className="flex w-full gap-4 h-auto items-top justify-stretch">
					{/* Dashboard content */}
					<div className="px-4 py-6 sm:px-0">
					<p className="text-base mb-6">{t("page_scans_instructions")}</p>
						<div>
						{/* Only let ADMIN and SUPERUSER users pick which user to administer */ }
						{ (userType == 'ADMIN' || userType == 'SUPERUSER') &&
						<PickUser
							loginToken={loginToken}
							setSelectedUserId={setSelectedUserId}
							filter={(user) => user.type === 'REGULAR'}
							refreshTrigger={refreshTrigger} /> }
						</div>

						{/* TODO: To be updated when more components are added */}
						{/* ListOfBearers                                      */}
						{/*             |                                      */}
						{/*              \ ScanTokens \                        */}
						{/*                           |                        */}
						{/*                           + ScanTokenNameChange    */}
						{/*                           |                        */}
						{/*                            \ Scans                 */}
						{selectedUserId != 0 && <ListOfBearers
							loginToken={loginToken}
							userId={selectedUserId}
							setSelectedBearerId={setSelectedBearerId} /> }

						{selectedBearerId != 0 && <ScanTokens
							loginToken={loginToken}
							bearerId={selectedBearerId} /> }
					</div>
				</div>
			</div>
		</div>
	);
};

export default Scans;
